import React, { CSSProperties, useState } from 'react';
import * as styles from './index.module.less';

interface IProps {
  defaultValue?: boolean;
  className?: string;
  sliderClass?: string;
  sliderColor?: string;
  onChange?: (isChecked: boolean) => void;
}

const SwitchCom = ({ defaultValue = false, className, sliderClass, sliderColor = '#fff', onChange }: IProps) => {
  const [isChecked, setIsChecked] = useState(defaultValue);

  const toggleSwitch = () => {
    onChange?.(!isChecked);
    setIsChecked(!isChecked);
  };

  const sliderStyle = {
    '--slider-color': sliderColor,
  } as CSSProperties;

  return (
    <label className={`${className} ${styles.switch_wrapper}`}>
      <input type="checkbox" checked={isChecked} onChange={toggleSwitch} />
      <span style={{ ...sliderStyle }} className={`${sliderClass} ${styles.slider}`}></span>
    </label>
  );
};
export default SwitchCom;
